import * as _ from "lodash";
import * as angular from "angular";
import { Effort } from "../../models/effort.model";
import { EffortDataProvider } from "../../data-provider/effort.dp";
import { ExportDataProvider } from "../../data-provider/export.dp";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { Group } from "../../models/group.model";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { Filter } from "../../models/filter.model";
import { CheckManager } from "../../shared/check-manager";
import { SearchUtils } from "../../helper/search.helper";
import { SortPersistenceUtils } from "../../helper/sort-persistence.helper";
import { Assignment } from "../../models/assignment.model";
import { SortState } from "../shared/sortable-header/sortable-header.directive";

const SORT_STORAGE_KEY: string = "vc.lists.sort";

let GroupListComponent = {
    selector: "vcGroupList",
    templateUrl: "/angular/components/group/group-list.component.html",
    bindings: {
        selectedGroup: "=?",
    },
    controller: class GroupListController {
        // * bindings for typescript compiler *
        public selectedGroup?: any;
        // ************************************

        public checkManager: CheckManager;
        public filter: Filter;
        public subheading: string;
        public disableRefreshButton: boolean;
        public columns: any;
        public isLeaderView: boolean;
        public search: string;
        public sort: SortState = {
            column: null,
            direction: "desc",
        };
        public efforts: Effort[];
        public selectedEffort: Effort;
        public searchDelay: any;
        public previousFilter: object | undefined;

        private $scope: any;
        private $q: any;
        private $location: any;
        private $interval: any;
        private $window: any;
        private __env: any;
        private $cookies: any;
        private readonly $timeout: any;
        private dialog: DialogUtils;
        private toast: ToastUtils;

        public dataProvider: GroupDataProvider;
        public navigationBarService: NavigationBarHelperService;
        public permissionProvider: PermissionCheck;
        public exportDataProvider: ExportDataProvider;
        public searchUtils: SearchUtils;
        public filterDataProvider: FilterDataProvider;
        private readonly modelsUtils: any;
        private readonly sortPersistenceUtils: SortPersistenceUtils;

        constructor(
            $scope: any,
            $q: any,
            GroupDataProvider: GroupDataProvider,
            $location: any,
            $interval: any,
            PermissionCheck: PermissionCheck,
            $window: any,
            SearchUtils: SearchUtils,
            __app_type: string,
            NavigationBarHelperService: NavigationBarHelperService,
            ExportDataProvider: ExportDataProvider,
            FilterDataProvider: FilterDataProvider,
            EffortDataProvider: EffortDataProvider,
            __env: any,
            $cookies: any,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            ModelsUtils: any,
            $timeout: any,
            SortPersistenceUtils: SortPersistenceUtils
        ) {
            this.$scope = $scope;
            this.$q = $q;
            this.$location = $location;
            this.$interval = $interval;
            this.$window = $window;
            this.__env = __env;
            this.$cookies = $cookies;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.$timeout = $timeout;

            this.dataProvider = GroupDataProvider;
            this.exportDataProvider = ExportDataProvider;
            this.permissionProvider = PermissionCheck;
            this.searchUtils = SearchUtils;
            this.navigationBarService = NavigationBarHelperService;
            this.filterDataProvider = FilterDataProvider;
            this.modelsUtils = ModelsUtils;
            this.sortPersistenceUtils = SortPersistenceUtils;

            this.filterDataProvider.setPage("database");
            this.filter = this.filterDataProvider.appliedFilter;
            this.dataProvider.listView = this.$cookies.get("listView")
                ? this.$cookies.get("listView")
                : "people";
            this.isLeaderView = __app_type == "LEADER";
            this.subheading =
                "Here is where you will find your lists. You can cut turfs on the map page, or segment your database from the " +
                this.__env.strings.voters +
                " tab, making them easier to manage & enhances the accuracy on your results page";
            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = _.cloneDeep(
                    this.filter.search.values
                );
                this.search = this.searchUtils.searchText;
            }

            this.disableRefreshButton = this.dataProvider.disableRefreshButton;
            this.$scope.$watch(
                () => this.dataProvider.disableRefreshButton,
                (newValue: boolean, oldValue: boolean) => {
                    if (newValue != oldValue) {
                        this.disableRefreshButton =
                            this.dataProvider.disableRefreshButton;
                    }
                },
                true
            );

            this.dataProvider.getColumns().then((columns: any) => {
                this.columns = columns;
            });

            EffortDataProvider.getActiveEfforts().then((efforts: Effort[]) => {
                this.efforts = efforts;
            });

            this.searchUtils.setSearchBar(
                "Search Lists",
                (searchText: string) => {
                    this.search = searchText;
                    return this.$q.resolve([]); //Not using the results for the search dropdown so return empty.
                },
                null,
                true
            );

            this.checkManager = this.dataProvider.checkManager;
            this.checkManager.checkAll(false);

            this.$scope.$watch(
                () => this.dataProvider.listView,
                (newValue: any, oldValue: any) => {
                    if (oldValue != newValue) {
                        this.dataProvider.setFilters(this.filter);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.search,
                (newValue: any, oldValue: any) => {
                    if (oldValue != newValue) {
                        this.dataProvider.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.filterDataProvider.filter.search.values =
                                this.search;
                        }, 1000);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter,
                (newValue: Filter, oldValue: Filter) => {
                    if (
                        !this.previousFilter ||
                        (Object.keys(newValue).length &&
                            !Object.keys(oldValue).length) ||
                        (newValue &&
                            !angular.equals(
                                newValue.nonEmptyValues(),
                                oldValue.nonEmptyValues()
                            ))
                    ) {
                        this.previousFilter = _.cloneDeep(newValue);
                        this.dataProvider.setFilters(this.filter);
                    }
                },
                true
            );

            this.sort = this.sortPersistenceUtils.load(SORT_STORAGE_KEY);
            this.dataProvider.setSort(this.sort);
        }

        $onInit() {
            this.$timeout(() => {
                if (this.filterDataProvider.isSearchActive()) {
                    this.searchUtils.searchText = angular.copy(
                        this.filterDataProvider.non_empty_applied_fitlers.search
                    );
                    this.navigationBarService.setSearchMode(true);
                }
            }, 500);
        }

        scrollLoad(lastGroup: Group): void {
            // Skip if either a scroll-load or a fresh fetch (sort/filter
            // change) is already in flight — otherwise a scroll event
            // fired during a sort reset would request "page 2 of the new
            // sort" and abort the page-1 reset.
            if (
                !this.dataProvider.scrollLoading &&
                !this.dataProvider.loading
            ) {
                this.dataProvider.getFilteredGroups(lastGroup, true, this.sort);
            }
        }

        onSortChange(column: string): void {
            // Three-state cycle on the same column:
            //   inactive → asc → desc → inactive (back to default order)
            // A click on a different column always starts at asc.
            if (this.sort.column !== column) {
                this.sort = { column, direction: "asc" };
            } else if (this.sort.direction === "asc") {
                this.sort = { column, direction: "desc" };
            } else {
                this.sort = { column: null, direction: "desc" };
            }
            this.sortPersistenceUtils.save(SORT_STORAGE_KEY, this.sort);
            // Reset visible state immediately so the user sees the list
            // collapse to the top, then re-fill with the new sort. The
            // emptied array also satisfies the guard's
            // "groups.length < this.count" check so the fetch proceeds
            // even when everything was already loaded. We deliberately do
            // NOT clear count — sort doesn't change it, and the /filtered
            // endpoint skips returning count when we pass it as a param.
            this.dataProvider.groups.length = 0;
            this.dataProvider.getFilteredGroups(null, false, this.sort);
        }

        showBadgeHelp(ev: object): void {
            this.dialog.show({
                component: "vc-badge-help",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    showLocationNumbers: false,
                    pageName: "group",
                    __env: this.__env,
                },
            });
        }

        openGroupInfoDialog(group: Group, ev: object): void {
            this.dialog
                .show({
                    component: "vc-group-info-dialog",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        group: group,
                    },
                })
                .then((newGroup: Group) => {
                    angular.extend(group, newGroup);
                });
        }

        editGroupModal(
            group: Group,
            assign: boolean,
            autoSplitAssign: boolean,
            ev: object
        ): void {
            this.dialog
                .show({
                    component: "vc-create-group",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        group: group,
                        assign: assign,
                        autoSplitAssign: autoSplitAssign,
                    },
                })
                .then((newGroup: Group) => {
                    angular.extend(group, newGroup);
                });
        }

        viewOnMap(group: Group): void {
            this.$window.location = `/#/map?gid=${group.gid}`;
        }

        segmentDialog(group: Group, ev: object): void {
            this.dialog
                .show({
                    component: "vc-segment-group",
                    targetEvent: ev,
                    scope: this.$scope,
                    clickOutsideToClose: true,
                    locals: {
                        gid: group.gid,
                        created: false,
                    },
                    class: "large-dialog",
                    size: "large",
                })
                .then(() => {
                    this.dataProvider.setFilters(this.filter);
                });
        }

        groupClicked(group: Group): void {
            let selectedGroup = encodeURIComponent(
                JSON.stringify({
                    gid: group.gid,
                    gname: group.gname,
                    fid: group.fid,
                })
            );
            this.filter.search.values = "";
            this.filterDataProvider.appliedFilter.search.values = "";
            this.filterDataProvider.filter.search.values = "";
            this.searchUtils.searchText = "";

            let listView = this.$cookies.get("listView");
            listView = !listView ? "people" : listView;
            this.$window.location = `/#/${listView}?filter=${JSON.stringify(
                this.filter.nonEmptyValues()
            )}&group=${selectedGroup}`;
        }

        getStatus(statuses: object[], statusId: string): string {
            let returnValue = "";
            angular.forEach(statuses, (status: any) => {
                if (status.id == statusId) {
                    returnValue = status.count;
                }
            });
            return returnValue;
        }

        showExport($event: object): void {
            if (this.permissionProvider.hasPermission("EXPORT")) {
                this.dialog
                    .show({
                        component: "vc-export-dialog",
                        scope: this.$scope,
                        size: "x-large",
                        targetEvent: $event,
                    })
                    .then((exportChoices: any) => {
                        this.dataProvider.bulkExport(exportChoices).then(
                            () => {
                                this.toast
                                    .action("Export Started", "Show")
                                    .then((value: string) => {
                                        if (value == "ok") {
                                            if (this.isLeaderView) {
                                                this.$location.url(
                                                    "/leader_exports"
                                                );
                                            } else {
                                                this.$location.url("/exports");
                                            }
                                        }
                                    });
                                this.checkManager.checkAll(false);
                            },
                            () => this.toast.error()
                        );
                    });
            } else {
                this.dialog.show({
                    component: "vc-export-disabled-dialog",
                    size: "large",
                    scope: this.$scope,
                });
            }
        }

        // Returns true if the user may export. Otherwise shows the "export
        // disabled" dialog and returns false, so the buttons stay visible but
        // clicking them explains why the action is blocked.
        exportAllowed(): boolean {
            if (this.permissionProvider.hasPermission("EXPORT")) {
                return true;
            }
            this.dialog.show({
                component: "vc-export-disabled-dialog",
                size: "large",
                scope: this.$scope,
            });
            return false;
        }

        // Payload for a bulk boundary export. This is the standard bulk-action
        // payload ({ all_checked, checked_items, unchecked_items, filters, ... }),
        // so under "select all" the backend resolves the full set through the
        // same filter the Lists page is using — honouring the active filter and
        // never depending on which rows the client had loaded.
        boundaryExportPayload(): object {
            return this.checkManager.bulkActionData(this.dataProvider.filters);
        }

        deleteListModal(ev: object): void {
            const count = this.dataProvider.checkManager.checked_items_count;
            this.dialog
                .delete({
                    targetEvent: ev,
                    skipHide: true,
                    fullscreen: true,
                    locals: {
                        title: `Delete ${count} ${
                            count > 1 ? "Lists" : "List"
                        }?`,
                        bodyText: `This action will delete the selected ${
                            count > 1 ? "lists" : "list"
                        } only. The contacts will still remain in your database.`,
                    },
                })
                .then(() => {
                    this.dataProvider.bulkDelete().then(
                        () => this.toast.success("Lists deleted"),
                        () => this.toast.error()
                    );
                });
        }

        toggleGroupStatus(group: Group): void {
            group.gstatus =
                group.gstatus == "Done" || group.gstatus == "Pending"
                    ? "Active"
                    : "Done";
            group.update().then(
                () => this.toast.success("List status updated"),
                () => this.toast.error()
            );
        }

        exportWalkingList(group: Group, offset: number): void {
            this.exportDataProvider.walkingList(group.gid, offset).then(
                () => {
                    this.toast
                        .action("Export Started", "Show")
                        .then((value: string) => {
                            if (value == "ok") {
                                if (this.isLeaderView) {
                                    this.$location.url("/leader_exports");
                                } else {
                                    this.$location.url("/exports");
                                }
                            }
                        });
                },
                () => this.toast.error()
            );
        }

        exportGeoJson(group: Group): void {
            if (!this.exportAllowed()) {
                return;
            }
            this.exportDataProvider.geoJson(group.gid).then(
                () => {
                    this.toast
                        .action("Export Started", "Show")
                        .then((value: string) => {
                            if (value == "ok") {
                                if (this.isLeaderView) {
                                    this.$location.url("/leader_exports");
                                } else {
                                    this.$location.url("/exports");
                                }
                            }
                        });
                },
                () => this.toast.error()
            );
        }

        bulkExportGeoJson(): void {
            if (!this.exportAllowed()) {
                return;
            }
            this.exportDataProvider
                .geoJsonBulk(this.boundaryExportPayload())
                .then(
                    () => {
                        this.toast
                            .action("Export Started", "Show")
                            .then((value: string) => {
                                if (value == "ok") {
                                    if (this.isLeaderView) {
                                        this.$location.url("/leader_exports");
                                    } else {
                                        this.$location.url("/exports");
                                    }
                                }
                            });
                        this.checkManager.checkAll(false);
                    },
                    (json: any) => this.toast.error(json)
                );
        }

        exportKml(group: Group): void {
            if (!this.exportAllowed()) {
                return;
            }
            this.exportDataProvider.kml(group.gid).then(
                () => {
                    this.toast
                        .action("Export Started", "Show")
                        .then((value: string) => {
                            if (value == "ok") {
                                if (this.isLeaderView) {
                                    this.$location.url("/leader_exports");
                                } else {
                                    this.$location.url("/exports");
                                }
                            }
                        });
                },
                () => this.toast.error()
            );
        }

        bulkExportKml(): void {
            if (!this.exportAllowed()) {
                return;
            }
            this.exportDataProvider.kmlBulk(this.boundaryExportPayload()).then(
                () => {
                    this.toast
                        .action("Export Started", "Show")
                        .then((value: string) => {
                            if (value == "ok") {
                                if (this.isLeaderView) {
                                    this.$location.url("/leader_exports");
                                } else {
                                    this.$location.url("/exports");
                                }
                            }
                        });
                    this.checkManager.checkAll(false);
                },
                (json: any) => this.toast.error(json)
            );
        }

        exportShapefile(group: Group): void {
            if (!this.exportAllowed()) {
                return;
            }
            this.exportDataProvider.shapefile(group.gid).then(
                () => {
                    this.toast
                        .action("Export Started", "Show")
                        .then((value: string) => {
                            if (value == "ok") {
                                if (this.isLeaderView) {
                                    this.$location.url("/leader_exports");
                                } else {
                                    this.$location.url("/exports");
                                }
                            }
                        });
                },
                () => this.toast.error()
            );
        }

        bulkExportShapefile(): void {
            if (!this.exportAllowed()) {
                return;
            }
            this.exportDataProvider
                .shapefileBulk(this.boundaryExportPayload())
                .then(
                    () => {
                        this.toast
                            .action("Export Started", "Show")
                            .then((value: string) => {
                                if (value == "ok") {
                                    if (this.isLeaderView) {
                                        this.$location.url("/leader_exports");
                                    } else {
                                        this.$location.url("/exports");
                                    }
                                }
                            });
                        this.checkManager.checkAll(false);
                    },
                    (json: any) => this.toast.error(json)
                );
        }

        openViewGroupFiltersDialog(group: Group, ev: object): void {
            this.dialog.show({
                component: "vc-view-group-filters-dialog",
                targetEvent: ev,
                scope: this.$scope,
                clickOutsideToClose: true,
                locals: {
                    group,
                },
                ariaLabel: "View Group",
            });
        }

        refreshDynamicList(group: Group): void {
            this.disableRefreshButton = true;
            this.dataProvider.refreshDynamicList(group);
        }

        bulkRefreshDynamicList(): void {
            this.disableRefreshButton = true;
            this.dataProvider.bulkRefreshDynamicList();
        }

        setStatus(group: Group, status: string, ev: object): void {
            group.gstatus = status;
            group.update().then(
                () => this.toast.success("List status updated"),
                () => this.toast.error()
            );
        }

        bulkSetStatus(): void {
            const count = this.dataProvider.checkManager.checked_items_count;
            if (!this.permissionProvider.hasPermission("APPROVAL_NEEDED")) {
                this.dialog
                    .show({
                        component: "vc-group-status-update",
                        scope: this.$scope,
                    })
                    .then((status: any) => {
                        this.dataProvider.bulkUpdate(status).then(
                            () => {
                                this.toast.success("Lists updated");
                                this.checkManager.checkAll(false);
                            },
                            () => this.toast.error()
                        );
                    });
            }
        }

        bulkAssignFunction(): void {
            const count = this.dataProvider.checkManager.checked_items_count;
            this.dialog
                .show({
                    component: "vc-group-assignment",
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        listName: count + " lists",
                        assignment: this.modelsUtils.assignment({}),
                    },
                })
                .then((assignment: Assignment) => {
                    this.dataProvider.bulkAssign(assignment).then(
                        () => {
                            this.toast.success("Lists updated");
                            this.checkManager.checkAll(false);
                        },
                        () => this.toast.error()
                    );
                });
        }
    },
};

angular
    .module("group")
    .component(GroupListComponent.selector, GroupListComponent);
